module.exports = __webpack_public_path__ + "img/emoji-1.d98115df.png";